var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.appIsLoading)?_c('div',[_vm._t("default")],2):_c('div',[_c('AppPreloader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }